import type {ReactElement} from 'react';
import type {NotificationsListItemProps} from './notifications-list-item.types';
import {Text, TextSize} from '@Components/text';
import styles from './notifications-list-item.module.scss';
import {getDateFromUnixTimestamp, getTimeFromNowShort} from '@Utils/date.util';
import {ClickableDiv} from '@Components/clickable-div';

export function NotificationsListItem({...props}: NotificationsListItemProps): ReactElement {
  let combinedText = props.heading;
  if (props.message) {
    combinedText = `${props.heading} <span class="body-md-regular">"${props.message}"</span>`;
  } else if (props.userComment) {
    combinedText = `${props.heading} <span class="body-md-regular ${styles.commentText}">"${props.userComment}"</span>`;
  }

  return (
    <ClickableDiv onClick={props.onClick} className={`flexbox radius-8 ${styles.rowGapThumbnail}   ${props.isRead ? styles.markAsRead : styles.hoverEffects}`}>
      {props.notificationsThumbnail}
      <div className={`flex-v-row _full-width ${styles.rowGap}`}>
        <div className={`flexbox ${styles.headingMinHeight}`}>
          <Text val={combinedText} dangerouslySetInnerHTML className={`${props.isRead ? 'content-disabled' : ''} ${styles.lineLimitText}`} size={TextSize.XSMALL} />
          <div className={`body-sm-regular content-sub-text flex-row-align-center spacing-p-l-5 ${styles.timeWrapper}`}>
            <div className={`${props.showPulse ? 'bg-danger-100' : '_invisible'} ${styles.pulse} spacing-m-r-1 radius-round`}></div>
            <Text className={styles.timeText} size={TextSize.XXSMALL} val={getTimeFromNowShort(getDateFromUnixTimestamp(props.timePassed))} />
          </div>
        </div>
        {props.buttons ? <div className={`flexbox`}>{props.buttons}</div> : null}
      </div>
    </ClickableDiv>
  );
}
